import { Button } from "@medme/ui"
import { useTranslation } from "react-i18next"
import {
	isLeadsPageSize,
	LEADS_PAGE_SIZES,
	type LeadsPageSize,
} from "../model/constants"

type LeadsPaginationProps = {
	page: number
	pageSize: LeadsPageSize
	totalPages: number
	isFetching: boolean
	onPageChange: (page: number) => void
	onPageSizeChange: (pageSize: LeadsPageSize) => void
}

export function LeadsPagination({
	page,
	pageSize,
	totalPages,
	isFetching,
	onPageChange,
	onPageSizeChange,
}: LeadsPaginationProps) {
	const { t } = useTranslation()
	return (
		<nav
			aria-label={t("leads.pagination.label")}
			className="flex flex-col items-stretch justify-between gap-3 sm:flex-row sm:flex-wrap sm:items-center"
		>
			<label className="flex items-center gap-2 text-sm">
				{t("leads.pagination.rowsPerPage")}
				<select
					className="rounded-[10px] border border-mm-border bg-mm-card px-2 py-2 outline-none focus-visible:border-mm-primary focus-visible:ring-2 focus-visible:ring-mm-primary/20"
					value={pageSize}
					onChange={(event) => {
						const value = Number(event.target.value)
						if (isLeadsPageSize(value)) onPageSizeChange(value)
					}}
				>
					{LEADS_PAGE_SIZES.map((size) => (
						<option key={size}>{size}</option>
					))}
				</select>
			</label>
			<div className="flex items-center justify-between gap-2 sm:justify-end">
				<Button
					className="h-auto rounded-[10px] py-2"
					size="sm"
					variant="outline"
					disabled={page <= 1 || isFetching}
					onClick={() => onPageChange(page - 1)}
				>
					{t("leads.pagination.previous")}
				</Button>
				<span className="text-sm">
					{t("leads.pagination.pageOf", { page, totalPages })}
				</span>
				<Button
					className="h-auto rounded-[10px] py-2"
					size="sm"
					variant="outline"
					disabled={page >= totalPages || isFetching}
					onClick={() => onPageChange(page + 1)}
				>
					{t("leads.pagination.next")}
				</Button>
			</div>
		</nav>
	)
}
